import ResourcesAPI from '../../api/ResourcesAPI';
import {
  GET_COUPONS_REQUESTED,
  GET_COUPONS_SUCCESS,
  DELETE_COUPON_REQUESTED,
  ADD_COUPON_REQUESTED,
  UPDATE_COUPON_REQUESTED,
} from './CouponsActionTypes';
import {
  ERROR,
} from '../central/CentralActionTypes';

export function getCouponsSuccess(response) {
  return {
    type: GET_COUPONS_SUCCESS,
    response,
  };
}

export function getCoupons(apiToken) {
  return (dispatch) => {
    dispatch({ type: GET_COUPONS_REQUESTED });
    return ResourcesAPI.getAllResources(apiToken, ['coupons'])
      .then(response => dispatch(getCouponsSuccess(
        response.data,
      )),
      error => dispatch({
        type: ERROR,
        error,
      }));
  };
}

export function deleteCoupon(apiToken, couponId) {
  return dispatch => {
    dispatch({ type: DELETE_COUPON_REQUESTED });
    ResourcesAPI.deleteResource(apiToken, ['coupons', couponId])
    .then(
      () => dispatch(getCoupons(apiToken)),
      error => dispatch({
        type: ERROR,
        error,
      }),
    );
  }
}

export function addCoupon(apiToken, resource, ...resourcePath) {
  return (dispatch) => {
    dispatch({ type: ADD_COUPON_REQUESTED });
    return ResourcesAPI.addResource(apiToken, resource, resourcePath)
      .then(
        () => dispatch(getCoupons(apiToken)),
        error => dispatch({
          type: ERROR,
          error,
        }),
      );
  };
}

export function updateCoupon(apiToken, newResource, ...resourcePath) {
  return (dispatch) => {
    dispatch({ type: UPDATE_COUPON_REQUESTED });
    return ResourcesAPI.updateResource(apiToken, newResource, resourcePath)
      .then(
        () => dispatch(getCoupons(apiToken)),
        error => dispatch({
          type: ERROR,
          error,
        }),
      );
  };
}
